export const BRANDING_FONT_OPTIONS = [
  'Alegreya Sans',
  'Archivo',
  'Assistant',
  'Barlow',
  'Baskerville',
  'Bebas Neue',
  'Bitter',
  'Cabin',
  'Cardo',
  'Cormorant Garamond',
  'DM Sans',
  'Domine',
  'Figtree',
  'Fira Sans',
  'Frank Ruhl Libre',
  'IBM Plex Sans',
  'Inter',
  'Josefin Sans',
  'Lato',
  'Libre Baskerville',
  'Lora',
  'Manrope',
  'Merriweather',
  'Montserrat',
  'Mulish',
  'Nunito Sans',
  'Open Sans',
  'Oswald',
  'Playfair Display',
  'Plus Jakarta Sans',
  'Poppins',
  'PT Sans',
  'Public Sans',
  'Quicksand',
  'Raleway',
  'Roboto',
  'Source Sans 3',
  'Space Grotesk',
  'Spectral',
  'Urbanist',
  'Work Sans'
];

const GENERIC_FONT_FAMILIES = new Set(['serif', 'sans-serif', 'monospace', 'system-ui', 'cursive', 'fantasy']);

export function formatBrandingFontLabel(fontFamily) {
  const value = String(fontFamily || '').trim();
  if (!value) return 'Default';
  if (value === 'sans-serif') return 'Sans Serif';
  if (value === 'system-ui') return 'System UI';
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export function isWebBrandingFont(fontFamily) {
  const value = String(fontFamily || '').trim();
  if (!value) return false;
  return !GENERIC_FONT_FAMILIES.has(value.toLowerCase());
}

export function buildBrandingFontsHref(fontFamilies = []) {
  const uniqueFamilies = [...new Set(
    (Array.isArray(fontFamilies) ? fontFamilies : [])
      .map((font) => String(font || '').trim())
      .filter((font) => font && isWebBrandingFont(font))
  )];

  if (!uniqueFamilies.length) return '';

  const familyParams = uniqueFamilies
    .map((font) => `family=${encodeURIComponent(font).replace(/%20/g, '+')}`)
    .join('&');

  return `https://fonts.googleapis.com/css2?${familyParams}&display=swap`;
}

export function ensureBrandingFontsLoaded(fontFamilies = [], linkId = 'branding-fonts-stylesheet') {
  if (typeof document === 'undefined') return;

  const href = buildBrandingFontsHref(fontFamilies);
  const existing = document.getElementById(linkId);

  if (!href) {
    try {
      if (typeof existing?.remove === 'function') {
        existing.remove();
      } else if (existing && existing.parentNode && typeof existing.parentNode.contains === 'function' && existing.parentNode.contains(existing)) {
        existing.parentNode.removeChild(existing);
      }
    } catch (_) {}
    return;
  }

  if (existing) {
    if (existing.getAttribute('href') !== href) {
      existing.setAttribute('href', href);
    }
    return;
  }

  const link = document.createElement('link');
  link.id = linkId;
  link.rel = 'stylesheet';
  link.href = href;
  document.head.appendChild(link);
}
